import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setJobPaymentErrors, setPaymentInputValue} from "./jobPaymentActions";
import {billingPlaceholders} from "./jobPaymentFunctions";
import {formatCardNumber, getValidationErrors} from "../../../utilities/validation";
import {getSvgCardIcon} from "../../Icons/creditCardIcons";
import Misc from "../../../misc";


const JobPaymentPopupInput = (props) => {

  const {property, value, paymentErrors, setPaymentInputValue, setJobPaymentErrors, className} = props;

  const onPaymentInputChange = (event) => {
    const property = event.target.name;
    let value = (property === "cardNumber") ? event.target.value.replace(/ /g,"") : event.target.value;
    if (paymentErrors[property]) {
      const errors = getValidationErrors(value, property);
      if (!errors.length) {
        setJobPaymentErrors({
          [property]: errors
        })
      }
    }
    switch (property) {
      case "cardNumber": {
        if (value.length > 19) {
          return
        }
        value = formatCardNumber(value);
        break;
      }
      case "cardExpiryMonth":
      case "cardExpiryYear": {
        if (value && (value.length > 2 || !/^[0-9]*$/.test(value))) {
          return
        }
        break;
      }
      case "cardCvv": {
        if (value && (value.length > 4 || !/^[0-9]*$/.test(value))) {
          return
        }
        break;
      }
      default:
        break;
    }
    setPaymentInputValue({
      [property]: value
    })
  }

  const onPaymentInputBlur = (event) => {
    const value = event.target.value.trim();
    const property = event.target.name;
    setPaymentInputValue({
      [property]: value
    });
    const toValidateValue = (property === "cardNumber") ? event.target.value.replace(/ /g,"") : value;
    const errors = getValidationErrors(toValidateValue, property);
    if (errors.length || paymentErrors[property]) {
      setJobPaymentErrors({
        [property]: errors
      })
    }
  }

  const inputError = Array.isArray(paymentErrors[property]) && paymentErrors[property][0];

  let iconSvg = null;
  if (property === "cardNumber") {
    iconSvg = getSvgCardIcon(Misc.detectCardType(value.replace(/ /g,"")));
  }

  return (
    <div className={"job-payment__block-item relative " + (className || "")}>
      <label htmlFor={property} className={"material__label" + (inputError ? " material__error" : "")}>
        <FormattedMessage id={billingPlaceholders[property]}/>
        {inputError ? <span>* <FormattedMessage id={inputError}/></span> : null}
      </label>
      <input type="text"
             className={"material__input" + (inputError ? " material__input--error" : "")}
             placeholder=""
             name={property}
             id={property}
             value={value}
             onBlur={onPaymentInputBlur}
             onChange={onPaymentInputChange}/>
      {iconSvg || null}
    </div>
  )
};

JobPaymentPopupInput.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  className: PropTypes.string,
}

const mapStateToProps = (store) => {
  const {paymentErrors} = store.jobPaymentState;
  return {
    paymentErrors,
  };
};

const mapDispatchToProps = {
  setPaymentInputValue,
  setJobPaymentErrors,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupInput)
)
